import { render } from "./addressForm.vue?vue&type=template&id=92fce66e"
import script from "./addressForm.vue?vue&type=script&lang=js"
export * from "./addressForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__